import { PopupModal } from "../../components/PopupModal";
import CloseIcon from "../../assets/icons/x.svg?react";

export function ProviderSwitchModal({
  provider,
  onCancel,
}: {
  provider: any;
  onCancel: () => void;
}) {
  return (
    <PopupModal
      shouldStopPropagation={false}
      contentClassName="p-8 z-[2] w-[98%] self-center bg-white 
      rounded-2xl flex-col justify-start items-center gap-6 flex w-full w-[90%] md:mx-auto md:w-[500px] max-w-[500px] overflow-auto"
    >
      <div className="flex flex-col w-full">
        <div className="justify-end items-center gap-3 flex">
          <button
            onClick={onCancel}
            style={{ transform: "translate(15px,-15px)" }}
          >
            <CloseIcon className="w-5 h-5 opacity-80" />
          </button>
        </div>

        <div className="bg-white rounded-[16px]">
          <div className="text-center mb-6">
            <div className="text-center">
              <h2 className="text-xl font-bold text-black mb-4">
                Seems like you are looking to set{" "}
                {provider?.firstName ? (
                  <span className="text-primary">{`${provider.firstName} ${provider.lastName}`}</span>
                ) : (
                  "a provider"
                )}{" "}
                as your provider
              </h2>
            </div>
            <p className="text-lg text-gray-700 mb-4">
              If you want to switch providers or are currently waiting for a
              provider, please reach out to our support team.
            </p>
            <p className="text-sm text-gray-600">
              We're here to help you find the perfect match for your family's
              needs.
            </p>
          </div>

          <div className="flex flex-col gap-3 justify-center items-center">
            <div className="justify-start items-start gap-3 flex">
              {/* Phone pill - hidden on mobile, shows as icon on mobile */}
              <a
                href="tel:4783476197"
                className="hidden md:flex bg-secondary px-5 py-2 rounded-[40px] border text-darkText text-center text-xs sm:text-base font-medium hover:bg-secondary/80 transition-colors"
              >
                Questions? Call
                <span className="text-primary text-xs sm:text-base font-bold leading-snug ml-1">
                  (478) 347-6197
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </PopupModal>
  );
}